import styled from "styled-components";
import { apolloFontFamilySub, apolloFontSizeSub, apolloLineHeightBody, apolloSpaceInlineHalfX, apolloSpaceInset1HalfX, apolloSpaceInset1X, apolloSpaceInset2X, apolloSpaceStack1X, } from "@nexthink/apollo-tokens";
import ButtonIcon from "../button-icon/ButtonIcon";
import { apolloFontWeightBody } from "@nexthink/apollo-tokens/lib/tokens";
import Text from "../text/Text";
import { BOTTOM_BAR_HEIGHT } from "../bottom-bar/BottomBar.style";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
const DISPLAY_INLINE_FLEX = "inline-flex";
export const StyledActionBarContainer = styled.div.withConfig({ displayName: "StyledActionBarContainer_APC-7311-productShell", componentId: "sc-9bjamp" })(({ $hasBottomBar }) => ({
    position: "fixed",
    left: 56,
    right: 0,
    bottom: apolloSpaceInset2X,
    paddingBottom: $hasBottomBar ? BOTTOM_BAR_HEIGHT : 0,
    height: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
}));
export const StyledActionBar = styled.div.withConfig({ displayName: "StyledActionBar_APC-7311-productShell", componentId: "sc-1kogl2i" })(({ theme }) => ({
    display: DISPLAY_INLINE_FLEX,
    backgroundColor: theme.colors.apolloColorBackgroundPopover,
    borderRadius: apolloSpaceInlineHalfX,
    boxShadow: theme.colors.apolloBoxShadowTooltip,
}));
export const actionBarItemStyle = ({ theme }) => ({
    border: `1px solid ${theme.colors.apolloColorBackgroundPopover}`,
    borderRadius: 0,
    display: DISPLAY_INLINE_FLEX,
    alignItems: "center",
    margin: 0,
    backgroundColor: theme.colors.apolloColorBackgroundPopover,
    color: theme.colors.apolloColorTextPopoverPrimary,
    padding: `${getValueFromPixelString(apolloSpaceStack1X) - 2}px ${getValueFromPixelString(apolloSpaceInset2X) - 2}px`,
    fontFamily: apolloFontFamilySub,
    fontSize: apolloFontSizeSub,
    fontWeight: apolloFontWeightBody,
    lineHeight: apolloLineHeightBody,
    "&:focus-visible": {
        outline: `1px solid ${theme.colors.apolloColorStrokePopoverFocus} !important`,
    },
});
export const actionBarButtonItemStyle = ({ theme }) => (Object.assign(Object.assign({}, actionBarItemStyle({ theme })), { cursor: "pointer", "&:hover": {
        backgroundColor: theme.colors.apolloColorBackgroundPopoverHover,
        borderColor: theme.colors.apolloColorBackgroundPopoverHover,
    }, "&:disabled": {
        backgroundColor: theme.colors.apolloColorBackgroundPopover,
        borderColor: theme.colors.apolloColorBackgroundPopover,
        color: theme.colors.apolloColorTextPopoverDisabled,
    } }));
export const StyledActionBarTitle = styled(Text).withConfig({ displayName: "StyledActionBarTitle_APC-7311-productShell", componentId: "sc-1qaxzfx" })(({ theme }) => (Object.assign(Object.assign({}, actionBarItemStyle({ theme })), { background: "none", border: 0, color: theme.colors.apolloColorTextPopoverSecondary })));
export const StyledCloseButtonContainer = styled.div.withConfig({ displayName: "StyledCloseButtonContainer_APC-7311-productShell", componentId: "sc-99vthb" })(({ theme }) => ({
    display: DISPLAY_INLINE_FLEX,
    alignItems: "center",
    justifyContent: "center",
    padding: `0 ${apolloSpaceInset1HalfX}`,
    "& .close-button": {
        color: theme.colors.apolloColorTextPopoverSecondary,
        width: apolloSpaceInset1X,
        height: apolloSpaceInset1X,
    },
}));
export const StyledCloseButton = styled(ButtonIcon).withConfig({ displayName: "StyledCloseButton_APC-7311-productShell", componentId: "sc-1df60vq" })(({ theme }) => ({
    "& .close-button-icon": {
        color: theme.colors.apolloColorTextPopoverSecondary,
    },
    "&:focus-visible": {
        outline: `1px solid ${theme.colors.apolloColorStrokePopoverFocus} !important`,
        borderRadius: 0,
    },
}));
//# sourceMappingURL=ActionBar.style.js.map